module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ThemeView.js"));
	}, "ThemeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ThemeView!./src/pages/Shop/Home/Theme/ThemeView.js
// module id = 906
// module chunks = 438